import axios from "axios";
import { toast } from "react-toastify";
import { friendlyError } from "../../common/apiError";
import { logout } from "./userActions";
import { ToastObjects } from "./toastObject";
import {
    APP_TOKEN_LIST_REQUEST,
    APP_TOKEN_LIST_SUCCESS,
    APP_TOKEN_LIST_FAIL,
    APP_TOKEN_CREATE_REQUEST,
    APP_TOKEN_CREATE_SUCCESS,
    APP_TOKEN_CREATE_FAIL,
    APP_TOKEN_REVOKE_REQUEST,
    APP_TOKEN_REVOKE_SUCCESS,
    APP_TOKEN_REVOKE_FAIL,
} from "../constants/AppTokenConstants";

export const listAppTokens = (appId) => async (dispatch) => {
    try {
        dispatch({ type: APP_TOKEN_LIST_REQUEST });
        const response = await axios.get(`app/${appId}/tokens`);
        dispatch({ type: APP_TOKEN_LIST_SUCCESS, payload: response.data.data || [] });
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_TOKEN_LIST_FAIL, payload: error?.message });
    }
};

export const createAppToken = (appId, label) => async (dispatch) => {
    try {
        dispatch({ type: APP_TOKEN_CREATE_REQUEST });
        const response = await axios.post(`app/${appId}/tokens`, { label });
        dispatch({ type: APP_TOKEN_CREATE_SUCCESS, payload: response.data.data });
        toast.success(response.data.message || "Token created.", ToastObjects);
        dispatch(listAppTokens(appId));
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_TOKEN_CREATE_FAIL, payload: error?.message });
    }
};

export const revokeAppToken = (appId, tokenId) => async (dispatch) => {
    try {
        dispatch({ type: APP_TOKEN_REVOKE_REQUEST });
        const response = await axios.delete(`app/${appId}/tokens/${tokenId}`);
        dispatch({ type: APP_TOKEN_REVOKE_SUCCESS, payload: response.data.data });
        toast.success(response.data.message || "Token revoked.", ToastObjects);
        dispatch(listAppTokens(appId));
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_TOKEN_REVOKE_FAIL, payload: error?.message });
    }
};
